const extractSubstrings = (message: string, startChar: string, endChar: string) => {
  message = message.split(startChar)?.[1] || message.split(startChar)?.[0];
  message = message.split(endChar)?.[0];

  return message
}

export default extractSubstrings
